import { defineComponent as _defineComponent } from 'vue'
import { FitHalfScreenDialogV2, FitButton } from '@tencent/wphk-ui';
import { ref } from 'vue';
import { useActConfigStore } from '../../store/act-config';

export default /*#__PURE__*/_defineComponent({
  __name: 'act-info-dialog',
  setup(__props, { expose }) {

const { targetActConfig } = useActConfigStore();
const showActInfoDialog = () => {
  actInfoDialog.value.showDialog();
};
const actInfoDialog = ref();
const onCloseDialog = () => {
  actInfoDialog.value.hideDialog();
};
expose({
  showActInfoDialog,
});

return { __sfc: true,targetActConfig, showActInfoDialog, actInfoDialog, onCloseDialog, FitHalfScreenDialogV2, FitButton }
}

})